import React, { useCallback, useEffect } from 'react';
import { Link } from 'react-router-dom';

function renderBullet(bullet, index) {
  if (typeof bullet === 'string') {
    return <li key={index}>{bullet}</li>;
  }
  return (
    <li key={index}>
      {bullet.strong ? (
        <>
          <strong>{bullet.strong}</strong>
          {bullet.text ? `: ${bullet.text}` : ''}
        </>
      ) : (
        bullet.text
      )}
    </li>
  );
}

export default function ProjectDetailModal({ project, isOpen, onClose }) {
  const handleKeyDown = useCallback(
    (e) => {
      if (e.key === 'Escape') onClose();
    },
    [onClose]
  );

  useEffect(() => {
    if (!isOpen) return undefined;
    document.body.style.overflow = 'hidden';
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen, handleKeyDown]);

  if (!isOpen || !project) return null;

  return (
    <div
      className="project-modal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="project-modal-title"
      onClick={onClose}
    >
      <button
        type="button"
        className="project-modal__close"
        onClick={onClose}
        aria-label="Close"
      >
        ×
      </button>
      <div className="project-modal__panel" onClick={(e) => e.stopPropagation()}>
        <div className="project-modal__header">
          <h2 id="project-modal-title" className="project-modal__title">
            {project.title}
          </h2>
        </div>
        <div className="project-modal__body">
          {project.paragraphs?.map((paragraph) => (
            <p key={paragraph.slice(0, 40)}>{paragraph}</p>
          ))}
          {project.bullets?.length > 0 && (
            <ul className="project-modal__list">
              {project.bullets.map(renderBullet)}
            </ul>
          )}
          {project.footnote && (
            <p className="project-modal__footnote">
              <em>{project.footnote}</em>
            </p>
          )}
        </div>
        {project.contactLabel && (
          <div className="project-modal__footer">
            <Link
              to={project.contactPath || '/contactus'}
              className="bnt bnt-theme"
              onClick={onClose}
            >
              {project.contactLabel}
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}
